import { useEffect, useState } from "react";
import { Phone, MessageSquareText } from "lucide-react";
import { PHONE_HREF, PHONE_DISPLAY, smsHref, isIOS } from "@/lib/contact";
import { track } from "@/lib/track";

const VARIANTS = {
  primary: "bg-[#1F1E1C] text-[#F9F6F0] hover:bg-[#7A6547]",
  accent: "bg-[#7A6547] text-[#F9F6F0] hover:bg-[#5E4D35]",
  outline: "border border-[#7A6547] text-[#7A6547] hover:bg-[#7A6547] hover:text-[#F9F6F0]",
  gold: "border border-[#C8B387] text-[#C8B387] hover:bg-[#C8B387] hover:text-[#1F1E1C]",
  goldSolid: "bg-[#C8B387] text-[#1F1E1C] hover:bg-[#F3EDDF]",
  light: "bg-[#F9F6F0] text-[#1F1E1C] hover:bg-[#C8B387]",
  lightOutline: "border border-white/80 text-white hover:bg-white hover:text-[#1F1E1C]",
};

const base =
  "inline-flex items-center justify-center gap-2 px-5 py-3.5 min-h-[44px] text-[11px] tracking-[0.2em] uppercase transition-colors whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#C8B387]";

export const useSmsHref = (body) => {
  const [href, setHref] = useState(() => smsHref(body, false));
  useEffect(() => {
    setHref(smsHref(body, isIOS()));
  }, [body]);
  return href;
};

export const CallChrisButton = ({ source, variant = "primary", label = "Call Chris", showNumber = true, className = "", testid }) => (
  <a
    href={PHONE_HREF}
    onClick={() => track("call_click", source)}
    data-testid={testid || `${source}-call`}
    aria-label={`Call Chris at ${PHONE_DISPLAY}`}
    className={`${base} ${VARIANTS[variant]} ${className}`}
  >
    <Phone size={14} strokeWidth={1.5} aria-hidden="true" />
    <span>{label}</span>
    {showNumber && <span className="hidden md:inline opacity-80 tracking-[0.1em]">· {PHONE_DISPLAY}</span>}
  </a>
);

export const TextChrisButton = ({ source, body, variant = "outline", label = "Text Chris", className = "", testid }) => {
  const href = useSmsHref(body);
  return (
    <a
      href={href}
      onClick={() => track("text_click", source)}
      data-testid={testid || `${source}-text`}
      aria-label={`Text Chris at ${PHONE_DISPLAY}`}
      title={`Text ${PHONE_DISPLAY}`}
      className={`${base} ${VARIANTS[variant]} ${className}`}
    >
      <MessageSquareText size={14} strokeWidth={1.5} aria-hidden="true" />
      <span>{label}</span>
    </a>
  );
};

export const TextNote = ({ className = "", children }) => (
  <p className={`text-xs leading-snug ${className}`}>
    {children || "Texting opens your messaging app, where you can attach a photo before sending."}
  </p>
);
